module.exports = __webpack_public_path__ + "img/clouds.86f37f46.png";